import React, { Component } from "react";
import PropTypes from "prop-types";
import { Checkbox, Divider } from "antd";
import SelectorInfoPopover from "../../selector_info_popover/SelectorInfoPopover";

class InputSelectorMultiple extends Component {
  state = {
    options: this.props.options,
    selectedValues: this.props.selectedValues,
    disabledValues: this.props.disabledValues,
    onChange: this.props.onChange,
    collapseAtCount: this.props.collapseAtCount,
    showHidden: false
  };

  componentWillReceiveProps(newProps) {
    if (this.state.options !== newProps.options) {
      this.setState({
        options: newProps.options
      });
    }

    if (this.state.selectedValues !== newProps.selectedValues) {
      this.setState({
        selectedValues: newProps.selectedValues
      });
    }

    if (this.state.disabledValues !== newProps.disabledValues) {
      this.setState({
        disabledValues: newProps.disabledValues
      });
    }
  }

  onClickCheckbox = value => () => {
    const { selectedValues, onChange } = this.state;
    //toggle value on/off selected values list
    const idx = selectedValues.indexOf(value);

    if (idx >= 0)
      //if item already in array of selectedValues
      selectedValues.splice(idx, 1); //remove item
    else selectedValues.push(value); //add item to array

    //update parent
    onChange(selectedValues);
  };

  isDisabled = value => {
    const { disabledValues } = this.state;
    return disabledValues && disabledValues.indexOf(value) >= 0;
  };

  isChecked = value => {
    const { selectedValues } = this.state;
    return selectedValues && selectedValues.indexOf(value) >= 0;
  };

  onClickShowMore = () => {
    this.setState({ showHidden: true });
  };

  onClickShowLess = () => {
    this.setState({ showHidden: false });
  };

  render() {
    const { options, showHidden, collapseAtCount } = this.state;

    return (
      <div>
        {options
          .filter((o, i) => showHidden || (!showHidden && i < collapseAtCount))
          .map((o, i) => (
            <div key={o.value}>
              <Checkbox
                onChange={this.onClickCheckbox(o.value)}
                disabled={this.isDisabled(o.value)}
                checked={this.isChecked(o.value)}
              >
                {o.text}
                {o.description && (
                  <SelectorInfoPopover text={`${o.description} (${o.units})`} />
                )}
              </Checkbox>
              {i === collapseAtCount - 1 &&
                options.length > collapseAtCount && (
                  <Divider style={{ margin: 0, fontSize: "11px" }}>
                    {showHidden ? (
                      <a onClick={this.onClickShowLess}>show less</a>
                    ) : (
                      <a onClick={this.onClickShowMore}>show more</a>
                    )}
                  </Divider>
                )}
            </div>
          ))}
      </div>
    );
  }
}

InputSelectorMultiple.propTypes = {
  options: PropTypes.array.isRequired,
  selectedValues: PropTypes.array.isRequired,
  disabledValues: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  collapseAtCount: PropTypes.number.isRequired
};

export default InputSelectorMultiple;



// WEBPACK FOOTER //
// ./src/views/components/input_selector/input_selector_multiple/InputSelectorMultiple.jsx